module.exports = __webpack_public_path__ + "img/id-menu-1.44678377.svg";